import { useTranslations } from 'next-intl';

import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { SMALL_CARD_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import type { WebinarNodeProps } from '.';
import { WebinarNodeLink } from './GatedDrawer';

/**
 * Webinar node component for the small card display type.
 */

const WebinarNodeSmallCard = (props: WebinarNodeProps) => {
  const t = useTranslations();

  const { alias, image, title, customDate, format, link, isGated } = props;

  const upperTitle = format ? format.name : t('nodes.webinar.label');

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={SMALL_CARD_DISPLAY_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={SMALL_CARD_DISPLAY_IMAGE_SIZES} />
  );

  const renderedContent = (
    <Card gap="xs" justify="space-between" disabled={!link}>
      <Flex gap="xs" direction="column">
        <Card.Overlay>{renderedImage}</Card.Overlay>
        <Text as="h6" level="label-md" transform="uppercase" marginBottom="none">
          {upperTitle}
        </Text>
        <Card.Title>{title}</Card.Title>
      </Flex>
      <Text level="body-xs" transform="uppercase" marginBottom="none">
        {customDate}
      </Text>
    </Card>
  );

  if (link) {
    return (
      <WebinarNodeLink alias={alias} link={link} isGated={isGated}>
        {renderedContent}
      </WebinarNodeLink>
    );
  }

  return renderedContent;
};

export default WebinarNodeSmallCard;
